import { IFrameworkStrings } from 'framework/localization/IFrameworkStrings';
import { ILocalizationProps } from 'framework/context/LocalizationProvider';
import React from 'react';
import { LanguageOption } from './LanguageOption';

export const SpecificLocalizationContext = React.createContext<ILocalizationProps<IFrameworkStrings, LanguageOption>>(undefined as any);